import Agency from "./Guides/Agency";
import Route from "./Guides/Route";
import Stop from "./Guides/Stop";
import Trip from "./Guides/Trip";

const UserGuide = () => null;
UserGuide.Agency = Agency;
UserGuide.Route = Route;
UserGuide.Stop = Stop;
UserGuide.Trip = Trip;

export default UserGuide;
